"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dog = void 0;
class Dog {
    constructor(context) {
        this.context = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.name = undefined;
        this.breed = undefined;
        this.leaderUserId = undefined;
        this.leaderName = undefined;
        this.assignments = undefined;
        this.createdByUserId = undefined;
        this.createdByUserName = undefined;
        this.updateTimestamp = undefined;
        this.creationDate = undefined;
        this.context = context;
    }
    setFromAny(element) {
        const { creationDate, updateTimestamp, contextId, createdByUserId, createdByUserName, identifier, name, breed, leaderUserId, leaderName, assignments, } = element;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.name = name ? name : this.name;
        this.breed = breed ? breed : this.breed;
        this.leaderUserId = leaderUserId ? leaderUserId : this.leaderUserId;
        this.leaderName = leaderName ? leaderName : this.leaderName;
        this.assignments = assignments ? assignments : this.assignments;
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId;
        this.createdByUserName = createdByUserName ? createdByUserName : this.createdByUserName;
        this.updateTimestamp = updateTimestamp ? updateTimestamp : this.updateTimestamp;
        this.creationDate = creationDate ? creationDate : this.creationDate;
    }
    searchFilter(filter) {
        const str = `${this.name}${this.breed}${this.leaderName}${this.createdByUserName}`.toLowerCase();
        return str.includes(filter);
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        const list = ["context"];
        if (list.includes(key))
            return false;
        else
            return true;
    }
}
exports.Dog = Dog;
